import { useNavigation } from "@react-navigation/native";
import React, { useState } from "react";
import { StatusBar, StyleSheet, TouchableOpacity, View } from "react-native";
import { useSelector } from "react-redux";
import BackArrow from "@assets/svg/BackArrow";
import Text from "@components/AppText";
import FetchCMSEntity from "@components/CMS/FetchCMSEntity";
import colors from "@constants/color";
import metrics from "@constants/metrics";

import t from "@constants/localization";

import testIds from "../../constants/testIds";

const PATH = "screens/LeaderTraining/index";

const Index = (props) => {
  const [data, setData] = useState({});
  const navigation = useNavigation();

  const appSettings = useSelector((s) => s.configReducer.appSettings) || {};
  const { cmsPoweredEntities = {} } = appSettings || {};

  const CMS_KEY = "TRAINING_VIDEOS_PAGE";

  return (
    <>
      <StatusBar barStyle="dark-content" />

      <View
        style={styles.topNavContainer}
        testID={testIds.leader_training_container}
      >
        <View style={styles.topNav}>
          <TouchableOpacity
            onPress={() => {
              navigation.goBack();
            }}
            style={styles.arrowCont}
          >
            <BackArrow />
          </TouchableOpacity>
          <Text bold fontType="head1" style={styles.textLeftPadding}>
            {data?.cl_title || t(`${PATH}/trainingAcademy`)}
          </Text>
        </View>
      </View>
      {cmsPoweredEntities &&
      typeof cmsPoweredEntities === "object" &&
      CMS_KEY in cmsPoweredEntities ? (
        <FetchCMSEntity
          id={cmsPoweredEntities[CMS_KEY]}
          type="PAGE"
          fromVideoTraining={true}
        />
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  topNavContainer: {
    flexDirection: "row",
    paddingVertical: 18,
    paddingHorizontal: metrics.mainContainerPadding,
    backgroundColor: colors.white,
    alignItems: "center",
    alignContent: "space-around",
    justifyContent: "space-between",
  },
  topNav: { flexDirection: "row", alignItems: "center" },
  textLeftPadding: {
    paddingLeft: 36,
  },
});

export default Index;
